import { JobCompletedEnum, OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { WorkStations } from "../../workstations/workstations.entity";
import { ProductionInventory } from "../entities/production-inventory.entity";
import { ProductionLog } from "../entities/production-log.entity";
import { ProductionInventoryData } from "./production-inventory.dto";
import { ProductionLogData } from "./production-log.dto";

export class ProductionLogAdapter{
    public convertDtoToEntity(inputReq: ProductionLogData):ProductionLog{
        const productionLogObj = new ProductionLog();
        productionLogObj.lotNumber = inputReq.lotNumber;
        productionLogObj.subLotNumber = inputReq.lotNumber;
        productionLogObj.saleOrderId = inputReq.saleOrderId;
        productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
        productionLogObj.operationType = inputReq.operationType;
        productionLogObj.jobNumber = inputReq.jobNumber;
        productionLogObj.plantId = inputReq.plantId;
        if (inputReq.subPlantId) {
            productionLogObj.subPlantId = inputReq.subPlantId;
        }
        productionLogObj.workStationType = inputReq.workStationType;
        productionLogObj.workstation = new WorkStations();
        productionLogObj.workstation.workstationId = inputReq.workStation;
        productionLogObj.jobStatus = JobCompletedEnum.NO;
        productionLogObj.inputGrade = String(inputReq.inputGrade);
        productionLogObj.inputQuantity = inputReq.inputQuantity;
        productionLogObj.inputBoxes = inputReq.inputBoxes;
        productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
        productionLogObj.shift = inputReq.shift;
        productionLogObj.createdUser = inputReq.createdUser;
        return productionLogObj;
    }

    public convertEntityToDto(grnObject: ProductionLog): ProductionLogData {
        const grnDto= new ProductionLogData;
        grnDto.lotNumber = grnObject.lotNumber;
        grnDto.subLotNumber = grnObject.lotNumber;
        grnDto.saleOrderId = grnObject.saleOrderId;
        grnDto.saleOrderItemId = grnObject.saleOrderItemId;
        grnDto.operationType = grnObject.operationType;
        grnDto.jobNumber = grnObject.jobNumber;
        grnDto.plantId = grnObject.plantId;
        if (grnObject.subPlantId) {
            grnDto.subPlantId = grnObject.subPlantId;
        }
        grnDto.workStationType = grnObject.workStationType;
        grnDto.workStation = grnObject.workstation.workstationId;
        // grnDto.jobStatus = JobCompletedEnum.NO;
        grnDto.inputGrade = Number(grnObject.inputGrade);
        grnDto.inputQuantity = grnObject.inputQuantity;
        grnDto.inputBoxes = grnObject.inputBoxes;
        grnDto.createdUser = grnObject.assignedUser;//need to get assigned user
        grnDto.shift = grnObject.shift;
        grnDto.createdUser = grnObject.createdUser;
        return grnDto;
      }
}